export default {
    'add-company': 'إضافة شركة',
    'edit-company': 'تعديل شركة',
    'this-company': 'هذه الشركة'
}